import { render, staticRenderFns } from "./SidebarAccount.vue?vue&type=template&id=8f2cbc10"
import script from "./SidebarAccount.vue?vue&type=script&lang=js"
export * from "./SidebarAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports